import HeroSection from "@/components/home/HeroSection";
import ServicesSection from "@/components/home/ServicesSection";
import ValuesSection from "@/components/home/ValuesSection";
import FaqSection from "@/components/home/FaqSection";
import CtaSection from "@/components/home/CtaSection";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col p-0 overflow-hidden">
      <HeroSection />
      <ServicesSection />
      <ValuesSection />
      <FaqSection />
      <CtaSection />
    </div>
  );
}